export default "__VITE_ASSET__e6wNWO13__"